import ServiceSectionA from "./Sections/ServiceSectionA"
import ServiceSectionB from "./Sections/ServiceSectionB"

const Service = () => (
    <>
    <ServiceSectionA/>
    <ServiceSectionB/>
    </>
)

export default Service